document.addEventListener('DOMContentLoaded', function () {
  const btn = document.getElementById('load-more-btn');
  if (!btn) return;

  btn.addEventListener('click', function () {
    const nextUrl = btn.getAttribute('data-next-url');
    const sectionId = btn.getAttribute('data-section');
    const spinner = document.getElementById('load-more-spinner');
    if (!nextUrl) return;

    btn.disabled = true;
    spinner.style.display = 'block';

    const url = new URL(nextUrl, window.location.origin);
    url.searchParams.set('section_id', sectionId);

    fetch(url.toString())
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newItems = doc.querySelectorAll('#product-grid > li, #product-grid > div');
        const currentGrid = document.getElementById('product-grid');
        newItems.forEach((item) => currentGrid.appendChild(item));

        const newBtn = doc.getElementById('load-more-btn');
        if (newBtn) {
          const newNextUrl = newBtn.getAttribute('data-next-url');
          if (newNextUrl) {
            btn.setAttribute('data-next-url', newNextUrl);
          } else {
            btn.remove();
          }
        } else {
          btn.remove();
        }
      })
      .catch((err) => {
        console.error('Load more failed:', err);
      })
      .finally(() => {
        btn.disabled = false;
        spinner.style.display = 'none';
      });
  });
});